import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdatePage as UpdatePageMutation,
    UpdatePageVariables as UpdatePageMutationVariables,
    PageUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_PAGE from '../mutations/update-page.graphql';

export function useUpdatePage(): {
    updatePage: (arg1: PageUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [pageUpdate, {loading: isLoading, error}] = useMutation<
        UpdatePageMutation,
        UpdatePageMutationVariables
    >(UPDATE_PAGE);

    return {
        updatePage: (input: PageUpdateInput) =>
            pageUpdate({
                variables: {input},
            }),
        isLoading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
